<template>
    <div class="icon" :class="[small ? 'small' : '', flip ? 'flip' : '']">        
        <img :src="require('@/assets/images/' + icon)" alt="">        
    </div>
</template>

<script>
export default {
  name: "RoundIcon",  
  data: () => ({}),
  props: { 
      icon:String, 
      small: {
          default:false,
          type:Boolean
      }, 
      flip: {
          default:false,
          type:Boolean
      }, 
    },
};
</script>


<style lang="scss" scoped>
.icon {    
    width:45px;
    height:45px;
    background: linear-gradient(180deg, #FFFFFF 0.38%, #9E9E9E 99.68%);
    border-radius: 100%;
    padding:10px;
    box-sizing: border-box;
    position: relative;
    &.flip {        
        transform: scaleX(-1)        
    }
    &.small {
        width:30px;
        height:30px;
    }
    img {
        position: absolute;
        top:50%;
        left:50%;
        transform: translate(-50%, -50%);        
    }
}
</style>
